import { FileCheck2, FileSignature, ReceiptText } from 'lucide-react'

const formatAmount = (value, currency) => {
  const numeric = typeof value === 'string' ? Number(value) : value
  if (typeof numeric !== 'number' || Number.isNaN(numeric)) return null
  return `${numeric.toFixed(2)} ${currency}`
}

const TYPE_META = {
  QUOTE: { label: 'Devis', icon: ReceiptText, accent: 'text-emerald-600 bg-emerald-50' },
  CONTRACT: { label: 'Contrat', icon: FileSignature, accent: 'text-[hsl(var(--primary))] bg-[hsl(var(--primary)/0.08)]' },
  INVOICE: { label: 'Facture', icon: FileCheck2, accent: 'text-amber-600 bg-amber-50' },
}

const STATUS_META = {
  SENT: { label: 'Envoyé', className: 'text-[hsl(var(--primary))] bg-[hsl(var(--primary)/0.08)]' },
  VIEWED: { label: 'Consulté', className: 'text-amber-700 bg-amber-50' },
  SIGNED: { label: 'Signé', className: 'text-green-700 bg-green-50' },
  REJECTED: { label: 'Refusé', className: 'text-red-700 bg-red-50' },
  CANCELLED: { label: 'Annulé', className: 'text-slate-500 bg-slate-100' },
  PAID: { label: 'Payé', className: 'text-green-700 bg-green-50' },
  DRAFT: { label: 'Brouillon', className: 'text-slate-500 bg-slate-100' },
}

export default function DocumentCard({ document, onPress }) {
  const typeMeta = TYPE_META[document.type] ?? TYPE_META.CONTRACT
  const statusMeta = STATUS_META[document.status] ?? STATUS_META.DRAFT
  const TypeIcon = typeMeta.icon
  const amountLabel = formatAmount(document.totalAmount, document.currency ?? 'EUR')

  return (
    <button
      type="button"
      onClick={onPress}
      className="w-full max-w-sm text-left rounded-xl border border-slate-200 bg-white p-3 hover:bg-slate-50 transition-colors"
    >
      <div className="flex items-center justify-between gap-2 mb-2">
        <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-semibold ${typeMeta.accent}`}>
          <TypeIcon className="w-3.5 h-3.5" />
          {typeMeta.label}
        </span>
        <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold ${statusMeta.className}`}>
          {statusMeta.label}
        </span>
      </div>
      <p className="font-semibold text-slate-900 line-clamp-2">{document.title}</p>
      {amountLabel && <p className="text-sm text-slate-500 mt-1">{amountLabel}</p>}
    </button>
  )
}
